import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { integrationApiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";
import { LoginResponse } from "../../../../utils/getLoginResponse";

const exchangeSsoTokenRequest = async (ssoToken: string) => {
  const url = `${integrationApiV1Endpoint}/integration/ssoExchange`;

  const response = await axios.get<ApiResponse<LoginResponse>>(url, {
    params: { ssoToken },
    headers: { appName: "institutionalLandlordPortal" },
  });

  return response.data.result;
};

type UseExchangeSsoTokenOptions = {
  ssoToken: string | null;
  enabled?: boolean;
};

export const useExchangeSsoToken = ({ ssoToken, enabled = true }: UseExchangeSsoTokenOptions) => {
  const { data, ...rest } = useQuery({
    queryKey: ["exchange-sso-token", ssoToken],
    queryFn: () => exchangeSsoTokenRequest(ssoToken),
    enabled: enabled && !!ssoToken,
    retry: false,
  });

  return { ...rest, loginResult: data };
};
